import styled from "styled-components";

export const PageContentWrapper = styled.div`
  display: block;
  margin: 30px 32px 40px 32px;
  @media screen and (max-width: 670px){
    margin-right: 8px;
    margin-left: 8px;
  }
`;